<template>
  <v-progress-linear v-if="!user" indeterminate />
  <v-card v-else flat :class="cardClass + ' transparent'" dark>
    <v-card-text class="text-center">
      <v-dialog v-model="cropDialog" max-width="320" persistent>
        <crop
          :img="imgBlob"
          @crop="croppedImage = $event"
          @cancel="cropDialog = $event"
        />
      </v-dialog>
      <form>
        <label
          for="avatar"
          class="avatar-update"
          @click="!isWeb && (avatarDialog = true)"
        >
          <v-avatar color="primary" size="150">
            <img v-if="avatarPreview" :src="avatarPreview" alt />
            <v-icon v-else dark>mdi-account-circle</v-icon>
          </v-avatar>
          <v-icon class="avatar-update-icon" size="32">mdi-camera</v-icon>
        </label>
        <v-file-input
          class="d-none"
          dense
          outlined
          show-size
          id="avatar"
          label="Avatar *"
          :rules="fileRules"
          accept="image/png, image/jpeg, image/bmp"
          prepend-icon
          v-model="avatar"
          @change="onAvatarChange"
          required
          v-if="isWeb"
        />
        <template v-else>
          <v-file-input
            dense
            outlined
            class="d-none"
            show-size
            required
            prepend-icon
            label="Avatar *"
            accept="image/png, image/jpeg, image/bmp"
            v-model="avatar"
            :rules="fieldRules"
          />
          <v-dialog v-model="avatarDialog" width="500">
            <v-card>
              <v-card-text class="pt-6">
                <v-row>
                  <v-col>
                    <div
                      class="px-4 py-3 rounded-lg option-card flex-column"
                      style="height: 100%"
                      @click="uploadAvatar('Capture')"
                    >
                      <v-icon large>mdi-camera</v-icon>
                      <h3 class="mb-0">Capture</h3>
                    </div>
                  </v-col>
                  <v-col>
                    <div
                      class="px-4 py-3 rounded-lg option-card flex-column"
                      style="height: 100%"
                      @click="uploadAvatar('Choose from library')"
                    >
                      <v-icon large>mdi-image</v-icon>
                      <h3 class="mb-0">From library</h3>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-dialog>
        </template>
      </form>
    </v-card-text>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card-title class="justify-center py-0 font-weight-bold"
      >Welcome, {{ this.user.get("firstName") }}
      {{ this.user.get("lastName") }}</v-card-title
    >
    <v-card-text class="text-center">
      Manage your info, privacy, and security to make The DriverX work better
      for you.
    </v-card-text>
  </v-card>
</template>

<script>
import Parse from 'parse'
import { mapActions, mapGetters } from 'vuex'
import validationRules from '@/validation-rules'
import Crop from '@/components/common/Crop'

export default {
  components: { Crop },
  props: {
    cardClass: {
      type: String,
      default: ''
    },
    runAlert: Function
  },
  watch: {
    croppedImage (val) {
      if (val) {
        this.uploadEditFileToParseServer(val)
      }
    }
  },
  computed: mapGetters(['user', 'userObj']),
  data () {
    return {
      avatar: null,
      avatarPreview: null,
      isWeb: true,
      avatarDialog: false,
      cropDialog: false,
      imgBlob: null,
      croppedImage: null,
      isSelecting: false,
      ...validationRules,
      overlay: false
    }
  },
  methods: {
    ...mapActions(['updateUser']),
    onAvatarChange () {
      this.overlay = true
      if (this.avatar) {
        if (this.isWeb) {
          const reader = new FileReader()
          reader.readAsDataURL(this.avatar)
          reader.onload = () => {
            this.imgBlob = reader.result
            this.cropDialog = true
          }
          reader.onerror = (error) => {
            console.error(error)
          }
          return
        }
        // reader.readAsDataURL(this.avatar);
        /** Upload the file to the cloud and get the URL */
        let name = this.avatar.name
        name = name.replace(/[ ,]+/g, '-')
        const parseFile = new Parse.File(name, this.avatar)
        parseFile.addMetadata('tag', 'profile image')
        parseFile.addTag('textTag', name)
        parseFile
          .save()
          .then(() => {
            this.avatarPreview = parseFile._url
            // this.avatarURL = parseFile._url;
            /** Just save to user's profile */
            this.overlay = false
            this.updateUser({
              profilePicture: parseFile._url
            })
          })
          .catch(console.log)
      } else {
        this.avatarPreview = null
      }
    },
    uploadAvatar (type) {
      this.avatarDialog = false
      if (type === 'Capture') {
        this.capture()
      } else {
        this.chooseFromLibrary()
      }
    },
    capture () {
      // Take picture using device camera and retrieve image as base64-encoded string
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, {
        quality: 65,
        allowEdit: window.device.platform !== 'Android',
        targetWidth: 350,
        targetHeight: 500,
        correctOrientation: true,
        destinationType: window.Camera.DestinationType.DATA_URL
      })
    },
    chooseFromLibrary () {
      console.log('chooseFromLibrary')
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )
      // this.$refs.fileUploader.click();

      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, {
        quality: 65,
        allowEdit: window.device.platform !== 'Android',
        targetWidth: 350,
        targetHeight: 500,
        correctOrientation: true,
        destinationType: window.Camera.DestinationType.DATA_URL,
        sourceType: window.Camera.PictureSourceType.PHOTOLIBRARY,
        mediaType: window.Camera.MediaType.PICTURE
      })
    },
    async onPhotoEditDataSuccess (imageData) {
      alert(JSON.stringify(imageData))
      // window.clearCache();
      this.uploadEditFileToParseServer(imageData)
    },
    async onPhotoDataSuccess (imageData) {
      this.uploadEditFileToParseServer(imageData)
    },
    onFail (e) {
      this.cleanup()
      this.isSelecting = false
      this.loadingPreview = false
      this.toggleDialog({
        status: true,
        title: 'Error',
        message: 'Upload failed' + JSON.stringify(e)
      })
    },
    cleanup () {
      navigator.camera.cleanup()
    },
    async uploadEditFileToParseServer (imageData) {
      if (!this.isWeb) {
        this.cleanup()
      }
      const base64pic = 'data:image/jpeg;base64,' + imageData
      const imageName = Math.floor(Date.now() / 1000) // by AK
      const parseFile = new Parse.File(imageName, { // by AK
        base64: this.isWeb ? imageData : base64pic
      })
      parseFile.addMetadata('tag', 'profile image') // by AK
      parseFile.addTag('textTag', imageName) // by AK
      await parseFile.save().then(
        () => {
          this.overlay = false
          this.loadingPreview = false
          this.avatarURL = parseFile._url
          this.avatarPreview = parseFile._url
          this.updateUser({
            profilePicture: parseFile._url
          })
        },
        (error) => {
          this.loadingPreview = false
          console.log(JSON.stringify(error))
        }
      )
    },
    submit () {}
  },
  created () {
    this.avatarPreview = this.user.get('profilePicture')
  },
  mounted () {
    document.addEventListener(
      typeof cordova !== 'undefined' ? 'deviceready' : 'DOMContentLoaded',
      async () => {
        this.isWeb = typeof window.cordova === 'undefined'
      }
    )
  }
}
</script>

<style lang="scss">
.avatar-update {
  cursor: pointer;
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  &::after {
    content: "";
    position: absolute;
    height: 30%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.75);
    left: 0;
    bottom: 0;
  }
  &-icon {
    position: absolute !important;
    bottom: 0.4rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    color: #fff !important;
  }
}
</style>
